import styles from "./styles.module.scss";
import { FAQItem } from "./item";

const FAQ_DATA = {
  easyfit: [
    {
      question: "How will this program help me achieve my goal?",
      answer:
        "Your plan is custom to you, your needs and your fitness level. We include diverse sets of exercises to target every muscle group you selected, gradually increase intensity and encourage you to stay motivated.",
    },
    {
      question: "How long will it take to see results?",
      answer:
        "Results vary depending on individual factors such as starting fitness level, diet, and consistency. Generally, noticeable improvements can be seen in a few weeks.",
    },
    {
      question: "Where do I find my program?",
      answer:
        "After the purchase your plan and all the workout sets will become available to you. Everything is already divided by day and you can start your journey at any moment!",
    },
    {
      question:
        "What if the suggested workouts are too easy or too hard for me?",
      answer:
        "Our program adapts to your progress. You can adjust the difficulty level of exercises or swap them for alternative options that better suit your current fitness level. Plus, as you advance, the workouts will gradually become more challenging to keep you improving.",
    },
    {
      question: "Won't I be bored doing the same workouts over and over again?",
      answer:
        "Not at all! Our program includes a variety of exercises to keep things fresh and engaging. You’ll get different workout routines, challenges, and progression plans to prevent monotony. Plus, we continuously update the program to make sure you stay motivated and excited about your fitness journey.",
    },
  ],
  walky: [
    {
      question: "How will this program help me achieve my goal?",
      answer:
        "Our program is designed to make your goals achievable by turning walking into a structured, personalized plan that fits your lifestyle.Your plan gradually increases challenge to keep your body adapting without overwhelming you and step-by-step instructions, audio cues, and pace tips help you walk effectively and safely.",
    },
    {
      question: "How long will it take to see results?",
      answer:
        "Many users start noticing positive changes within 2–4 weeks—like improved energy, better mood, and feeling stronger during daily activities. Physical changes, such as weight loss or visible muscle tone, may take 6–8 weeks or more, depending on your starting point and lifestyle.",
    },
    {
      question: "Where do I find my program?",
      answer:
        "Once you’ve completed the quick setup in the app, your personalized walking program will be available right on your home screen/dashboard.",
    },
    {
      question: "What if the suggested workouts are too easy or too hard for me?",
      answer:
        "If a walk feels too easy, you can increase the duration, pace, or difficulty level. If it feels too challenging, you can slow the pace, shorten the time, or choose an easier option—without losing your progress. Make sure to listen to your body and adjust accordingly.",
    },
    {
      question: "Won't | be bored doing the same workouts over and over again?",
      answer:
        "Our walking plans are designed with variety in mind so every week feels fresh. By constantly changing pace, distance, and style, your walks stay fun, effective, and far from repetitive—so you look forward to every session.",
    },
  ],
};

export const FAQSection = ({ isWalky }) => {
  const faqData = isWalky ? FAQ_DATA.walky : FAQ_DATA.easyfit;

  return (
    <div className={styles.faqSection}>
      <h2 className={styles.title}>
       People often ask
      </h2>
      <p className={styles.hint}>
        Everything you need to know about the product and billing.
      </p>
      <div className={styles.faqContainer}>
        {faqData.map((item, index) => (
          <FAQItem
            key={index}
            question={item.question}
            answer={item.answer}
            defaultExpanded={index === 0}
          />
        ))}
      </div>
    </div>
  );
};
